import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/api/axios';
import type { DocumentsResponse } from '@/types/documentUpload';

const getAuditCaseDocuments = async (
  auditCaseUuid: string,
  moduleId: string,
): Promise<DocumentsResponse> => {
  const { data } = await api.get<DocumentsResponse>(`/audit-cases/${auditCaseUuid}/documents`, {
    params: { moduleId },
  });
  return data;
};

export const useGetAuditCaseDocuments = (
  auditCaseUuid: string,
  moduleId: string,
): UseQueryResult<DocumentsResponse, Error> => {
  return useQuery({
    queryKey: ['audit-case-documents', auditCaseUuid, moduleId],
    queryFn: () => getAuditCaseDocuments(auditCaseUuid, moduleId),
  });
};
